<div class="codebox d-flex flex-column align-items-center justify-content-center">
  <div class="d-flex">
    <p class="d-flex flex-column justify-content-center align-items-center kh-heading-sm kh-heading-sm-mob pb-2">
      {{ 'CREATE_FOLDER.FOLDER_NAME' | translate }}
    </p>
    <div class="close-modal-icon" (click)="closeModal()">
      <fa-icon [icon]="['fas','times']"></fa-icon>
    </div>
  </div>

  <div data-testid="new-folder-modal" class="info d-flex flex-column align-items-center justify-content-center w-100">
    <div class="code-input mb-3">
      <kh-common-input
        data-testid="folder-name-form"
        [controlType]="inputTypes.Text"
        [placeholder]="'CREATE_FOLDER.NEW_FOLDER_NAME_LABEL' | translate"
        [(ngModel)]="folderName"
        testId="folder-name-form">
      </kh-common-input>
    </div>
    <div class="d-flex justify-content-end w-100 gap-2">
      <button data-testid="folder-cancel-button" class="kh-secondary-button mr-kh-2" (click)="closeModal()" type="button">{{ 'CREATE_FOLDER.CANCEL' | translate }}</button>
      <button data-testid="folder-create-button" class="kh-primary-button" 
              (click)="createFolder()" 
              [disabled]="!folderName || folderName.trim() === ''">
        <span *ngIf="!isProcessing">{{ 'CREATE_FOLDER.CREATE' | translate }}</span>
        <span *ngIf="isProcessing">{{ 'CREATE_FOLDER.SUBMITTING' | translate }}</span>
      </button>
    </div>
  </div>
</div>


